const ZAPPIER_ENDPOINT = 'https://hooks.zapier.com/hooks/catch/3653385/qycmhb/'

export const sendEvent = (type, user, company = '', position = '') => {
  const path = window.location.search.replace('?', '')
  return user != null && fetch(ZAPPIER_ENDPOINT, {
    'method': 'POST',
    body: JSON.stringify({
      'Type': type,
      'Profile': user['_profile']['publicProfileURL'],
      'Name': user['_profile']['name'],
      'Company': company,
      'Position': position,
      'Email': user['_profile']['email'],
      'Date': (new Date()).toLocaleString('en-GB', { timeZone: 'Asia/Jerusalem' }),
      'Page': path || "default",
    })
  });
}



// WEBPACK FOOTER //
// ./src/events/index.js